// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rj_F","label":"styles_label__zoZvw"};